
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';
import { heroImages } from '../../../utils/images';

export default function HeroSection() {
  return (
    <section
      className="relative h-[85vh] min-h-[800px] bg-cover bg-center bg-no-repeat flex items-end"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url('${heroImages.main}')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-[120px]">
        <div className="text-white space-y-8 max-w-3xl">
          {/* Welcome Text */}
          <div className="space-y-4">
            <div className="text-gray-300 text-sm font-light tracking-[0.3em] uppercase">
              WELCOME TO MUSHENG
            </div>
            <h1 className="text-5xl lg:text-6xl font-light leading-tight tracking-tight">
              Global Partner in{' '}
              <span className="font-normal">
                Leather
              </span>{' '}
              & Outerwear Manufacturing
            </h1>
            <p className="text-lg text-gray-300 leading-relaxed font-light max-w-2xl">
              From design to delivery, trusted OEM & ODM solutions for fashion brands worldwide.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 pt-4">
            <Link to="/services">
              <Button size="md" className="bg-white !text-black hover:bg-gray-100 hover:!text-black font-normal px-8 py-2.5 text-base whitespace-nowrap tracking-wide !rounded-none">
                EXPLORE OUR SERVICES
                <i className="ri-arrow-right-line ml-2 !text-black"></i>
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" size="md" className="!border-0 text-white hover:bg-white hover:!text-black px-8 py-2.5 text-base whitespace-nowrap tracking-wide font-light !rounded-none shadow-[inset_0_0_0_1px_white] hover:shadow-none">
                CONTACT US
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
